// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-item[data-v-55e8cc7e] {\n  padding-left: 0;\n  padding-right: 0;\n}\n.sidebar-item[data-v-55e8cc7e]::before {\n  opacity: 0;\n  background-color: transparent;\n}\n.sidebar-item.v-list-item--active i[data-v-55e8cc7e] {\n  color: var(--default-green-color);\n}\n.sidebar-item__icon--opened[data-v-55e8cc7e] {\n  margin-right: 16px !important;\n}", ""]);
// Exports
module.exports = exports;
